import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import olMap from 'app/containers/Maps/SituationalAwareness/olMapController';

const MapStyled = styled.div`
    height: 200px;
    cursor: all-scroll;
    background-color: white;
    background-image: linear-gradient(45deg, #b0b0b0 25%, transparent 25%), linear-gradient(-45deg, #b0b0b0 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #b0b0b0 75%), linear-gradient(-45deg, transparent 75%, #b0b0b0 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    margin-bottom: 16px;
`;

const XYZPreview = ({ data, onResult }) => {
    const { url, apiKey, projection } = data || {};

    const [map, setMap] = useState();
    const [initMap, setInitMap] = useState(false);
    const [mapId] = useState(`xyzMapPreview-${Date.now()}`);

    useEffect(() => {
        const initializeMap = async () => {
            if (!map) {
                const previewMap = new olMap();
                setMap(previewMap);
            } else if (map && !initMap) {
                setInitMap(true);
                map.initEntityAboutMap(mapId);
            }
            if (map && initMap && url) {
                const result = await map.addXYZPreviewLayer({ layerId: data.id, url, apiKey, projection });
                onResult && onResult(result); 
            }
        };

        initializeMap();
    }, [map, initMap, url, apiKey, mapId, onResult, projection, data.id]);

    if (!url) {
        return null;
    }

    return (
        <div>
            <MapStyled id={mapId} />
        </div>
    );
};

XYZPreview.propTypes = {
    data: PropTypes.object,
    onResult: PropTypes.func
};

export default XYZPreview;